import angular from 'angular';
import _ from 'lodash-es';
import APIV5 from '~/models/api';

class HelpFactory {
	#deferred;

	/** @type {Record<string,import('@knitiv/api-client-javascript').UIGetContentHelpToolip[]>} */
	#helps;

	/** @type {string[]} */
	#ids;

	#loading;

	/**
	 * @param {import('angular').IQService} $q
	 * @param {import('angular').ITimeoutService} $timeout
	 */
	constructor(
		$q,
		$timeout,
	) {
		this.#deferred = $q.defer();
		this.#helps = {};
		this.#ids = [];
		this.#loading = false;

		this.$q = $q;
		this.$timeout = $timeout;
	}

	async call() {
		this.#loading = false;

		if (this.#ids.length > 0) {
			const result = await APIV5.instance.uiGetContentHelp({ params: { ids: this.#ids } }, {
				id: 'help',
			});
			if (result) {
				_.merge(this.#helps, result.result);
			}
			this.#ids.length = 0;
		}
	}

	/**
	 * @param {string} id
	 * @returns {Promise<Record<string,import('@knitiv/api-client-javascript').UIGetContentHelpToolip[]>>}
	 */
	async request(id) {
		if (!(id in this.#helps)) {
			this.#ids.push(id);
			if (!this.#loading) {
				this.#loading = true;
				this.$timeout(() => this.call(), 150);
			}
		}
		return this.#helps;
	}
}

const helpFactory = /* @ngInject */ (
	/** @type {import('angular').IQService} */ $q,
	/** @type {import('angular').ITimeoutService} */ $timeout,
) => new HelpFactory($q, $timeout);

/**
 * @ngdoc service
 * @name app.Help
 * @description
 * # HelpFactory
 * Factory in the app.
 */
angular.module('app')
	.factory('Help', helpFactory);
